import React from 'react';
import PropTypes from 'prop-types';

import { getDurationString, getFormattedDateTime } from 'common/timeHelpers';

import SrTooltip, {
  SR_TOOLTIP_ICON_QUESTION_MARK,
  SR_TOOLTIP_POSITION_CENTER,
} from 'client/components/SrTooltip';
import SrFlexRow from 'client/components/SrFlexRow/SrFlexRow';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';

const SrSetupHealthGoLiveSectionItem = ({
  title,
  stepDescription,
  isOverdue,
  maxWidth,
  isActive,
  startDate,
  endDate,
  startLabel,
  endLabel,
}) => {

  const _getTimeDuration = () => {
    if (
      !startDate
      || typeof startDate !== 'string'
      || (endDate && typeof endDate !== 'string')
    ) {
      return '';
    }
    const duration = getDurationString({
      startTimestamp: startDate,
      endTimestamp: endDate,
    });
    return duration || '';
  };

  const _getTimeDurationComponent = () => {
    const timeDuration = _getTimeDuration();
    const timeDurationTextComponent = timeDuration
      ?
      (
        <SrText
          font='greycliff'
          color={
            isOverdue
              ? 'orange300'
              : 'black'
          }
          opacity={
            isActive
              ? 1
              : 0.5
          }
          fontSize='17px'
          lineHeight='20px'
          weight='800'
          cursor='pointer'
        >
          {timeDuration}
        </SrText>
      ) :
      (
        <SrText
          font='greycliff'
          color='grey200'
          fontSize='17px'
          lineHeight='20px'
          weight='800'
          cursor='pointer'
        >
          N/A
        </SrText>
      );

    const formattedStartDate = startDate
      ? getFormattedDateTime(startDate)
      : 'N/A';

    const formattedEndDate = endDate
      ? getFormattedDateTime(endDate)
      : startDate
        ? 'In progress'
        : 'N/A';

    return (
      <SrTooltip
        icon={timeDurationTextComponent}
        position={SR_TOOLTIP_POSITION_CENTER}
        className='tooltip-healthIndicator'
        bgColor='blueBright'
      >
        <SrFlexRow>
          <SrText
            whiteSpace='nowrap'
            font='greycliff'
            fontSize='14px'
            lineHeight='18px'
          >
            {startLabel}: {formattedStartDate}
          </SrText>
        </SrFlexRow>
        <SrFlexRow>
          <SrText
            whiteSpace='nowrap'
            font='greycliff'
            fontSize='14px'
            lineHeight='18px'
          >
            {endLabel}: {formattedEndDate}
          </SrText>
        </SrFlexRow>
      </SrTooltip>
    );
  };

  const _getStepDescriptionTooltipComponent = () => {
    if (!stepDescription) {
      return null;
    }

    return (
      <SrTooltip
        iconName={SR_TOOLTIP_ICON_QUESTION_MARK}
        position={SR_TOOLTIP_POSITION_CENTER}
        className='tooltip-healthIndicator'
        bgColor='blueBright'
      >
        {stepDescription}
      </SrTooltip>
    );
  };

  const timeDurationComponent = _getTimeDurationComponent();
  const stepDescriptionTooltipComponent = _getStepDescriptionTooltipComponent();

  return (
    <SrBox>
      <SrFlexRow>
        {timeDurationComponent}
      </SrFlexRow>
      <SrBox
        marginTop='5px'
        maxWidth={maxWidth || '90px'}
      >
        <SrText
          font='greycliff'
          color='grey'
          fontSize='15px'
          lineHeight='20px'
          weight='700'
        >
          {title}&nbsp;{stepDescriptionTooltipComponent}
        </SrText>
      </SrBox>
    </SrBox>
  );
};

SrSetupHealthGoLiveSectionItem.propTypes = {
  title: PropTypes.string.isRequired,
  stepDescription: PropTypes.string,
  isOverdue: PropTypes.bool,
  maxWidth: PropTypes.string,
  isActive: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
};

export default SrSetupHealthGoLiveSectionItem;
